import { useEffect } from 'react'
import { annexationStatusLabel } from '../../utils/annexation'

const SOURCE = 'my-annexations'
const FILL = 'my-annexations-fill'
const BORDER = 'my-annexations-border'
const LABEL = 'my-annexations-label'

const asGeoJSON = (regionsData, annexations) => {
  const byRegion = new Map((annexations || []).map((request) => [
    Number(request.payload?.region_id), request,
  ]))
  return {
    type: 'FeatureCollection',
    features: (regionsData?.features || []).filter((feature) => (
      byRegion.has(Number(feature.properties?.region_id))
    )).map((feature) => {
      const request = byRegion.get(Number(feature.properties.region_id))
      return {
        ...feature,
        properties: {
          ...feature.properties,
          annexation_status: request.status,
          annexation_label: `Annexion · ${annexationStatusLabel(request.status)}`,
        },
      }
    }),
  }
}

export function useAnnexations(map, { regionsData, annexations }) {
  useEffect(() => {
    if (!map.current?.getLayer('regions-fill')) return
    const data = asGeoJSON(regionsData, annexations)
    const source = map.current.getSource(SOURCE)
    if (source) {
      source.setData(data)
      return
    }

    map.current.addSource(SOURCE, { type: 'geojson', data })
    map.current.addLayer({
      id: FILL,
      type: 'fill',
      source: SOURCE,
      paint: { 'fill-color': '#d5b654', 'fill-opacity': 0.22 },
    })
    map.current.addLayer({
      id: BORDER,
      type: 'line',
      source: SOURCE,
      paint: {
        'line-color': '#ffe38a',
        'line-width': 4,
        'line-dasharray': [2, 1],
      },
    })
    map.current.addLayer({
      id: LABEL,
      type: 'symbol',
      source: SOURCE,
      layout: {
        'text-field': ['get', 'annexation_label'],
        'text-size': 12,
        'text-allow-overlap': false,
      },
      paint: {
        'text-color': '#fff3c4',
        'text-halo-color': '#332600',
        'text-halo-width': 2,
      },
    })
  }, [map, regionsData, annexations])
}
